import { ClassCard } from '../../../components/class-card';
import { ClassCardOptions } from '../../../components/class-card/class-card.options';
import { useClassroomCapabilities } from '../../../hooks/use-classroom-capabilities';
import { Classroom } from '../../../modules/classroom';

type Props = {
  classroom: Classroom;
  isDisabled?: boolean;
  options: ClassCardOptions;
  onClick: () => void;
};

export function SchoolClassroomCard({
  classroom,
  isDisabled = false,
  options,
  onClick,
}: Props): JSX.Element {
  const {
    classroom: { shouldShowAlias },
  } = useClassroomCapabilities({ classroom });

  const getSubtitle = () => {
    return shouldShowAlias ? classroom.name : classroom.courseName;
  };

  const getTitle = () => {
    return shouldShowAlias ? classroom.alias : classroom.name;
  };

  return (
    <ClassCard
      isDisabled={isDisabled}
      title={getTitle()}
      subtitle={getSubtitle()}
      classroom={classroom}
      options={options}
      onClick={onClick}
    />
  );
}
